module.exports = __webpack_public_path__ + "media/images/icons/icon_webinar_series-4ae9a16f7e4c5334ba507356ff64522f.svg";